const constants = require('./src/helpers/constants');

exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  window.history.scrollRestoration = 'manual';
  const [savedScrollPositionLeft, savedScrollPositionTop] = getSavedScrollPosition(location) || [0, 0];

  if (
    location.pathname === constants.ROUTES.SHORT_COURSES ||
    location.pathname === constants.ROUTES.SUBJECT_ATOZ ||
    location.pathname === constants.ROUTES.MICROCRENTIALS ||
    location.pathname === constants.ROUTES.CREATIVE_ARTS ||
    location.pathname === constants.ROUTES.WIDL_FAQS ||
    location.pathname === constants.ROUTES.POSTGRADUATE_A2Z_SUBJECTS ||
    location.pathname.includes(constants.ROUTES.ACCESS_MODULES) ||
    location.pathname.includes(constants.ROUTES.SHORT_COURSES) ||
    (location.hash && location.hash === `#${constants.SITE_ANCHOR}`) ||
    (location.hash && location.hash === `#${constants.PRODUCT_LIST_ANCHOR}`)
  )
    return;

  setTimeout(() => {
    window.scrollTo({
      top: savedScrollPositionTop,
      left: savedScrollPositionLeft,
      behavior: 'instant',
    });
  }, 600);

  return false;
};
